<kiwi-spacer [size]="16"></kiwi-spacer>

<div class="cell shrink decisionClosure">
    <i class="fas fa-exclamation-triangle decisionClosure-icon"></i>
    <span class="decisionClosure-text">
        <span [i18nKey]="'decisions.closure.info.decisions.of'"></span>
        <span class="decisionClosure-text-bold"><kiwi-period [period]="currentPeriod"></kiwi-period></span>
        <span [i18nKey]="'decisions.closure.info.are.closed'"></span>
    </span>
</div>
